module.exports = __webpack_public_path__ + "static/slide-4-ace496de503609c3185dede4adc5ed86.jpg";